import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { EnisSyncService, EnisSync, EnisSyncParticipant } from '../services/enis-sync.service';

@Component({
  selector: 'app-enis-sync-log',
  templateUrl: './enis-sync-log.component.html',
  styleUrls: ['./enis-sync-log.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatIconModule
  ]
})
export class EnisSyncLogComponent implements OnInit {
  latestSync?: EnisSync;
  loading = true;
  error?: string;
  displayedColumns: string[] = ['enisNumber', 'participantName', 'type', 'center', 'status', 'missingFields', 'errorMessage'];

  constructor(private enisSyncService: EnisSyncService) {}

  ngOnInit(): void {
    this.loadLatestSync();
  }

  loadLatestSync(): void {
    this.loading = true;
    this.error = undefined;

    this.enisSyncService.getLatestEnisSync().subscribe({
      next: (data) => {
        this.latestSync = data;
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Failed to load ENISSYNC log. ' + (err.message || '');
        this.loading = false;
      }
    });
  }

  getStatusColor(status: string): string {
    switch (status.toLowerCase()) {
      case 'success':
      case 'created':
      case 'updated':
        return 'primary';
      case 'failed':
        return 'warn';
      case 'skipped':
        return 'accent';
      default:
        return '';
    }
  }

  getStatusIcon(status: string): string {
    switch (status.toLowerCase()) {
      case 'success':
      case 'created':
      case 'updated':
        return 'check_circle';
      case 'failed':
        return 'error';
      case 'skipped':
        return 'info';
      default:
        return 'help';
    }
  }

  getMissingFieldsList(participant: EnisSyncParticipant): string[] {
    if ((participant as any).missingFieldsArray) {
      return (participant as any).missingFieldsArray;
    }
    if (participant.missingFields) {
      try {
        return JSON.parse(participant.missingFields);
      } catch (e) {
        return [];
      }
    }
    return [];
  }

  formatDate(date: Date | string | undefined): string {
    if (!date) return 'N/A';
    const d = new Date(date);
    return d.toLocaleString('en-GB', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }
}
